let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("66nqw")).then(() => parcelRequire('d16oc'));